<div class="flex flex-col w-full h-auto justify-center items-center text-center align-middle text-colored">
    <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke-width="1.5" stroke="currentColor"
        class="w-16 h-16  animate-spin">
        <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
    </svg> -->
    <app-animation></app-animation>
    <p class="text-xl">Caricamento in corso <span class="one">.</span><span class="two">.</span><span class="three">.</span></p>
</div>